module.exports = __webpack_public_path__ + "static/media/profile.901a941f.jpg";